<template>
  <ListagemBase
    nomePlural="funcionarioPreContratracaoDocumentos"
    nomeSingular="FuncionarioPreContratracaoDocumentos"
    :headers="headers"
  >
  </ListagemBase>
</template>

<script>
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDocumentosDataService";
import ListagemBase from "@/components/base/Crud/ListagemBase";

export default {
  name: "ListagemFuncionarioPreContratracaoDocumentos",
  components: { ListagemBase },
  data() {
    return {
      DataService,
      headers: [
        { text: this.$t("Descricao"), value: "descricao", sortable: "false" },
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: "false",
        },
        { text: this.$t("Status"), value: "statusComum", sortable: "false" },
        { text: this.$t("Data"), value: "dtInclusao", sortable: "false" },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
};
</script>

<style></style>
